import * as styles from '@/styles/Box';
import { PropsFromComponent } from '@/types/component';
import { GenericComponent } from 'base/components/GenericComponent';

export type BoxProps = PropsFromComponent<typeof Box>;

export const Box = GenericComponent({ styles });
